module.exports = __webpack_public_path__ + "static/media/evergreen-tree-icon.59f906a4.png";